import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { parse } from 'query-string';

import { AppState } from 'types/app';
import { HYDRA_PRODUCT_TYPE_CLASSIFIER_TEST } from 'constants/hydraTests';
import { isAssigned, triggerAssignment } from 'actions/ab';
import { termAutoFacetingAPI } from 'apis/calypso';
import { sessionExpiration, setAndStoreCookie, setSessionCookies } from 'actions/session';
import { processHeadersMiddleware } from 'middleware/processHeadersMiddlewareFactory';
import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { SageMakerReponse } from 'types/calypso';
import marketplace from 'cfg/marketplace.json';
import { SEARCH_AUTO_FACET_COOKIE } from 'constants/cookies';

const { domain } = marketplace;

export const fetchFromTermAutoFaceting =
  ({ location, searchFetch = () => Promise.resolve({}) }: { location: Location; searchFetch: () => Promise<{}> }) =>
  (dispatch: ThunkDispatch<AppState, void, AnyAction>, getState: () => AppState): Promise<Response<SageMakerReponse> | {}> => {
    const appState = getState();
    const isAssignedHydraProductTypeClassierTest = isAssigned(HYDRA_PRODUCT_TYPE_CLASSIFIER_TEST, 1, appState);
    const isExplicitlyNotAssignedHydraProductTypeClassierTest = isAssigned(HYDRA_PRODUCT_TYPE_CLASSIFIER_TEST, 0, appState);
    const {
      environmentConfig: {
        api: { calypso }
      },
      cookies
    } = appState;
    const { term } = parse(location?.search);
    const expiration = sessionExpiration();
    const isPtctTurnedOff = true;

    // PTCT - We are not doing this logic atm .. this is backed out by just returning the search
    if (isPtctTurnedOff) {
      dispatch(setAndStoreCookie(SEARCH_AUTO_FACET_COOKIE, 'off', expiration));
      return searchFetch();
    }

    if (isAssignedHydraProductTypeClassierTest || domain !== 'zappos' || !term?.trim() || term === 'null') {
      return searchFetch();
    }

    if (isExplicitlyNotAssignedHydraProductTypeClassierTest) {
      dispatch(setAndStoreCookie(SEARCH_AUTO_FACET_COOKIE, 'off', expiration));
      return searchFetch();
    }

    return termAutoFacetingAPI({ calypso, cookies, state: appState, location })
      .then(processHeadersMiddleware(setSessionCookies(dispatch, getState)))
      .then(fetchErrorMiddleware)
      .then((response: SageMakerReponse) => {
        const { predictions } = response;
        // This data is not used atm its just to trigger the test for the backend to send new facets for search
        if (predictions.length > 0) {
          dispatch(triggerAssignment(HYDRA_PRODUCT_TYPE_CLASSIFIER_TEST));
          dispatch(setAndStoreCookie(SEARCH_AUTO_FACET_COOKIE, '', expiration));
        }
        return searchFetch();
      })
      .catch(() => searchFetch());
  };
